module.exports = __webpack_public_path__ + "9c5da58eae44287aa4d082718aa8eed1.svg";